import script from "./ReservationForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReservationForm.vue?vue&type=script&lang=ts&setup=true"

import "./ReservationForm.vue?vue&type=style&index=0&id=1826017e&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/bookonline/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1826017e"]])

export default __exports__